export default "__VITE_ASSET__z8IqaDpT53LmDJcH$tHz3g__ 480w, __VITE_ASSET__479VhuutRPKqW_6Ht6iXzA__ 745w";